export default {
  uploadedFile: {}
}
